export default {
  uploadedFile: {}
}
